import { createContext, useContext, useState } from 'react';

const CreateRecordFormContext = createContext();

export const FormProvider = ({ children }) => {
  const [formState, setFormState] = useState({});

  const updateField = (fieldName, value) => {
    setFormState((prev) => ({
      ...prev,
      [fieldName]: value,
    }));
  };

  const resetForm = () => {
    setFormState({});
  };

  const setFormValues = (values = {}) => {
    setFormState(values || {});
  };

  return (
    <CreateRecordFormContext.Provider value={{ formState, updateField, resetForm, setFormValues }}>
      {children}
    </CreateRecordFormContext.Provider>
  );
};

export const useFormContext = () => useContext(CreateRecordFormContext);
